import type { AccessContent, AccessFunction, AccessId, AccessService } from "~domain/auth/models/access-model.ts";
import type { AccessToken, RefreshToken } from "~domain/auth/models/authentication-model.ts";
import type { OperatorId } from "~domain/operators/models/operator-model.ts";

import { z } from "zod";

export const backofficeAuthenticationResponseSchema = z.object({
  access_token: z.string().transform((s) => s as AccessToken),
  expires_in: z.number(),
  jti: z.string(),
  refresh_token: z.string().transform((s) => s as RefreshToken),
  scope: z.string(),
  token_type: z.string(),
});

export const backofficeCurrentOperatorResponseSchema = z.object({
  firstname: z.string(),
  id: z.number().transform((s) => s as OperatorId),
  lastname: z.string(),
});

export const backofficeOperatorAccess = z.object({
  content: z.string().transform((s) => s as AccessContent),
  function: z.string().transform((s) => s as AccessFunction),
  id: z.number().transform((s) => s as AccessId),
  service: z.string().transform((s) => s as AccessService),
});

export type BackofficeAuthenticationResponse = z.infer<typeof backofficeAuthenticationResponseSchema>;
